module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view', {
    key: _vm.$route.fullPath
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7b2025bc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Root.vue
// module id = 1618
// module chunks = 32